import AltHealing from './AltHealing'

export default AltHealing
// eslint-disable-next-line import/export
export * from './AltHealing'
